import React from 'react';
import { DeviationTypes } from '../../../types/deviation';
import { getDeviationType } from '../../_helpers';
import PollThumb from './Poll';
import StatusThumb from './Status';
import DefaultThumb from './Default';
import TierThumb from './Tier';
import type { StandardThumbProps } from './types';

const StandardThumb: React.FC<StandardThumbProps> = props => {
  const type = getDeviationType(props.deviation);
  switch (type) {
    case DeviationTypes.POLL:
      return <PollThumb {...props} />;
    case DeviationTypes.STATUS:
      return <StatusThumb {...props} />;
    case DeviationTypes.TIER:
      return <TierThumb {...props} />;
    default:
      return <DefaultThumb {...props} />;
  }
};
StandardThumb.displayName = 'StandardThumb';

export default StandardThumb;
